import { render } from "./OrderConfirmationFailure.vue?vue&type=template&id=4f0e8cb1"
import script from "./OrderConfirmationFailure.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationFailure.vue?vue&type=script&lang=js"

import "./OrderConfirmationFailure.vue?vue&type=style&index=0&id=4f0e8cb1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__